import React from 'react';
import {SocialProofMobileData} from '../mockData';
import {SocialProofItem} from '../shared/components/social-proof-item/social-proof-item.react-component';
import {useScrollProgress} from '../shared/hooks/use-scroll-progress';
import styles from './social-proof-mobile.module.scss';

export const SocialProofMobile: React.FC = () => {
    const {containerRef, scrollProgress} = useScrollProgress();

    return (
        <section ref={containerRef} className={styles.mobileSocialProof} key="mobile-social-proof">
            <div className={styles['social-proof-header']}>
                <h2>What hustlers are saying about Udemy</h2>
            </div>
            <div className={styles.mobileContent}>
                {SocialProofMobileData.map((item, index) => (
                    <SocialProofItem
                        key={index}
                        item={item}
                        index={index}
                        variant="mobile"
                        scrollProgress={scrollProgress}
                    />
                ))}
            </div>
        </section>
    );
};
